// useUiStore.ts
import { create } from 'zustand';

export const useUiStore = create((set) => ({
  focusedMessageId: null,
  setFocusedMessageId: (id) => set({ focusedMessageId: id }),
  contextMenuOpen: false,
  setContextMenuOpen: (open) => set({ contextMenuOpen: open }),
}));